export default class Software {
  public static AUTO = 1;
  public static KEYLOOP = 2;
  public static THIRD_PARTY = 3;
}
